import {
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
  Box,
} from '@chakra-ui/react'
import { AccordionList } from "../../molecules/SidebarAccordionPanelList";
import { AccordionItemLink } from "../../molecules/SidebarAccordionItemLink";


export const ManzokudoLaboAccordionMenu = () => {
  return (
    <AccordionItem border='none'>
      <AccordionButton px='10px' py={0} >
        <Box as="span" flex='1' textAlign='left' fontWeight='bold'>
          満足度ラボ
        </Box>
        <AccordionIcon />
      </AccordionButton>
      <AccordionPanel>
        <AccordionList>
          <AccordionItemLink to={`manzokudo-labo/qr-code`} text="QRコード" />
          <AccordionItem border='none'>
            <AccordionButton px='10px' py={1} >
              <Box flex='1' textAlign='left' fontWeight='bold'>
                アンケート
              </Box>
              <AccordionIcon />
            </AccordionButton>
            <AccordionPanel>
              <AccordionList>
                <AccordionItemLink to={`manzokudo-labo/survey/questions`} text="アンケート設定" />
                <AccordionItemLink to={`manzokudo-labo/survey/questions/selected`} text="アンケートセット" />
              </AccordionList>
            </AccordionPanel>
          </AccordionItem>
          <AccordionItemLink to={`manzokudo-labo/scores`} text="データ解析" />
          <AccordionItemLink to={`manzokudo-labo/setting`} text="設定" />
        </AccordionList>
      </AccordionPanel>
    </AccordionItem>
  );
};